import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b660b68c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "info-name" }
const _hoisted_4 = { class: "sn-tag-line" }
const _hoisted_5 = { class: "info-sn" }
const _hoisted_6 = {
  key: 0,
  class: "service-time"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "tips-item"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "no-data-box xag-flex-center"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "device-no-data-icon" }),
  /*#__PURE__*/_createElementVNode("div", null, "暂无设备")
], -1))
const _hoisted_14 = [
  _hoisted_13
]

import { watch, ref } from 'vue'
import { showNormalToast } from '@/utils/tools'
import { PullRefresh, List, Checkbox } from 'vant'
import { commonErrorHandle } from '@/utils/error-handle'
import { getRepairDeviceList } from '@/apis/malfunction-repair'
import { ComputedRef, computed, withDefaults } from 'vue'
import { isValueAddService, judgeIsQualityIn } from '@/defination/malfunction-repair'
import { useMalfunctionRepairDeviceTimeFormat } from '@/compositions/malfunction-repair'

import type {
  MalfunctionRepairDeviceItem,
  GetMalfunctionRepairDevicesQuery,
  MalfunctionRepairDeviceListRenderItem,
} from '@/types/malfunction-repair'
import useCommonList, { PageListResut } from '@/compositions/useCommonList'
import XcareTypeTag from './xcare-type-tag.vue'
import { MalfunctionRepairDeviceTypeStorage } from '@/storage/malfunction-repair'


export default /*#__PURE__*/_defineComponent({
  __name: 'fault-device-list',
  props: {
    needCheckDeviceCheck: { type: Boolean, default: false },
    scanDevice: { default: null },
    eq_type: { default: 0 },
    selectedList: { default: () => [] }
  },
  emits: ['change', 'deviceSnMapChange'],
  setup(__props: any, { emit: emits }) {

const props = __props as { needCheckDeviceCheck: boolean, scanDevice: MalfunctionRepairDeviceItem | null, eq_type: 0 | 1 | 2, selectedList: MalfunctionRepairDeviceListRenderItem[] };



const defaultSelectedGuidMap = computed(() => {
  return props.selectedList.reduce((result, item) => {
    result[item.guid] = true
    return result
  }, {} as Record<string, boolean>)
})
const { serviceTimeFormat } = useMalfunctionRepairDeviceTimeFormat()

async function queryList(
  params: GetMalfunctionRepairDevicesQuery
): Promise<PageListResut<MalfunctionRepairDeviceListRenderItem>> {
  try {
    let paramsProxy = {
      ...params,
      eq_type: props.eq_type,
    }
    let device_type = MalfunctionRepairDeviceTypeStorage.get()
    if (device_type) {
      paramsProxy.device_type = device_type
    }
    const data = await getRepairDeviceList(paramsProxy)
    return {
      ...data,
      data: data.data
        .filter((item) =>
          refreshing.value ? true : !queryDataDeviceSnMap.value[item.serial_number]
        )
        .map((item) => ({
          ...item,
          // 下拉刷新时，已选中的需要回填
          // 如果已经时默认置顶的数据，此时checked不需要勾选
          checked: defaultSelectedGuidMap.value[item.guid]
            ? false
            : !!selectedGuidMap.value[item.guid],
        })),
    }
  } catch (error) {
    commonErrorHandle(error)
    return Promise.reject(error)
  }
}
const {
  refreshing,
  loading,
  requestError,
  finished,
  onRefresh,
  dataList,
  queryHandle,
  finishedText,
  unshiftDataList,
} = useCommonList<MalfunctionRepairDeviceListRenderItem, GetMalfunctionRepairDevicesQuery>(
  queryList,
  {
    emptyText: '暂无设备',
  }
)

const queryDataDeviceSnMap: ComputedRef<Record<string, boolean>> = computed(() => {
  // 注意这里必须使用dataList, 如果使用renderList会导致defaultSelected的数据使得dataList里的被过滤
  return dataList.value.reduce((result, item) => {
    result[item.serial_number] = true
    return result
  }, {} as Record<string, boolean>)
})
const selectedDevices: ComputedRef<MalfunctionRepairDeviceListRenderItem[]> = computed(() => {
  return renderList.value.filter((item) => item.checked)
})
const selectedGuidMap: ComputedRef<Record<string, boolean>> = computed(() => {
  return selectedDevices.value.reduce((result, item) => {
    result[item.guid] = true
    return result
  }, {} as Record<string, boolean>)
})
const renderList = computed(() => {
  return props.selectedList.concat(
    dataList.value.filter((item) => !defaultSelectedGuidMap.value[item.guid])
  )
})
watch(
  () => queryDataDeviceSnMap.value,
  () => {
    console.log('change', queryDataDeviceSnMap.value)
    emits('deviceSnMapChange', queryDataDeviceSnMap.value)
  }
)
// 监听序列号录入
function scanHandle(data: MalfunctionRepairDeviceItem) {
  /*
    1. 扫描设备默认要选中并置顶于列表（后续分页获取的飞机需要过滤）
    2. 如果已选的是整机，清除选择
    3. 如果已选的是其他设备，扫描的是整机时，清除所有其他设备已选；如果扫描的是其他设备，添加改设备
  */
  const scanItem: MalfunctionRepairDeviceListRenderItem = {
    ...data,
    checked: true,
  }
  if (scanItem.type === 1 || isSelectedUav.value) {
    // 如果已选的是整机或者扫描的是整机时
    selectedDevices.value.forEach((item) => {
      item.checked = false
    })
  }
  unshiftDataList(scanItem)
  changeHandle()
}
function judgeHasServiceTime(item: MalfunctionRepairDeviceListRenderItem) {
  return isValueAddService(item.xcare_type) || judgeIsQualityIn(item.is_quality)
}
function judgeShowQualityInfo(item: MalfunctionRepairDeviceListRenderItem) {
  return (
    (item.type === 1 && !judgeHasServiceTime(item)) || (item.type !== 1 && item.is_quality == 2)
  )
}
function getServiceTypeName(item: MalfunctionRepairDeviceItem) {
  return isValueAddService(item.xcare_type) ? '增值服务' : '质保服务'
}
function getServiceTimeStartValue(item: MalfunctionRepairDeviceItem) {
  const valueInfo = serviceTimeFormat(
    isValueAddService(item.xcare_type) ? item.xcare : item.quality
  )
  return valueInfo.start
}
function getServiceTimeEndValue(item: MalfunctionRepairDeviceItem) {
  const valueInfo = serviceTimeFormat(
    isValueAddService(item.xcare_type) ? item.xcare : item.quality
  )
  return valueInfo.end
}
watch(
  () => props.scanDevice,
  () => {
    if (props.scanDevice) {
      scanHandle(props.scanDevice)
    }
  }
)
const isSelectedUav = computed(() => {
  return selectedDevices.value.length === 1 && selectedDevices.value[0].type === 1
})

function changeHandle() {
  emits('change', selectedDevices.value)
}
function clickHandle(item: MalfunctionRepairDeviceListRenderItem) {
  if (selectedGuidMap.value[item.guid]) {
    item.checked = !item.checked
    changeHandle()
    return
  }
  const noticeMessage = '植保机平台仅支持单设备独立提单，配套产品支持批量提单。'
  if (selectedDevices.value.length === 0) {
    item.checked = !item.checked
  } else if (isSelectedUav.value) {
    // 已选择整机的情况下，不能再选择其他东西
    showNormalToast(noticeMessage)
  } else {
    // 已选择多个或者一个的时候该产品不是整机
    if (item.type === 1) {
      showNormalToast(noticeMessage)
    } else {
      item.checked = !item.checked
    }
  }
  changeHandle()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PullRefresh), {
    modelValue: _unref(refreshing),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(refreshing) ? (refreshing).value = $event : null)),
    onRefresh: _unref(onRefresh),
    disabled: "",
    class: "list-wrap"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(List), {
        loading: _unref(loading),
        "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null)),
        error: _unref(requestError),
        "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => (_isRef(requestError) ? (requestError).value = $event : null)),
        finished: _unref(finished),
        offset: 200,
        "finished-text": _unref(finishedText),
        "error-text": "加载失败",
        onLoad: _unref(queryHandle),
        class: _normalizeClass(["list-container", _unref(renderList).length === 0 ? 'empty-wrap' : ''])
      }, {
        finished: _withCtx(() => [
          (_unref(renderList).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(finishedText)), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderList), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.guid,
              class: _normalizeClass(["device-item nongfu-checkbox-wrap", item.checked ? 'device-active active-item' : '']),
              onClick: _withModifiers(($event: any) => (clickHandle(item)), ["stop"])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, "SN：" + _toDisplayString(item.serial_number), 1),
                  _createVNode(XcareTypeTag, {
                    is_quality: item.is_quality,
                    xcare_type: item.xcare_type,
                    mode: "onlyTag",
                    activate_at: item.activate_at,
                    xcare: item.xcare,
                    quality: item.quality
                  }, null, 8, ["is_quality", "xcare_type", "activate_at", "xcare", "quality"])
                ]),
                (judgeHasServiceTime(item))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createTextVNode(_toDisplayString(getServiceTypeName(item)) + "：", 1),
                      _createElementVNode("span", null, _toDisplayString(getServiceTimeStartValue(item)), 1),
                      _createTextVNode(_toDisplayString(getServiceTimeEndValue(item)), 1),
                      _hoisted_7
                    ]))
                  : _createCommentVNode("", true),
                (judgeShowQualityInfo(item))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("div", null, [
                        _createTextVNode("质保已过保"),
                        (item.type !== 4)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "，且无增值服务"))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_1))
          }), 128))
        ]),
        _: 1
      }, 8, ["loading", "error", "finished", "finished-text", "onLoad", "class"])
    ]),
    _: 1
  }, 8, ["modelValue", "onRefresh"]))
}
}

})